<template>
  <div id="errorPage" class="grey-body">
    <div class="error-message">
      <div class="container-fluid">
        <div class="row justify-content-center text-center">
          <div class="col-lg-12">
            <div class="bg-white p-5 text-left">
              <img class="error-text" :src="$router.options.imagePath + 'logo/error.svg'" />
              <div class="headline-module-medium text-left">
                The page you requested is D.O.A.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="error-logo">
      <img :src="$router.options.imagePath + 'logo/error-logo.svg'" />
    </div>
    <div class="error-bg black-border" />
  </div>
</template>
<script>
export default {
  name: 'Error404'
};
</script>
<style scoped>
.error-logo {
  position: absolute;
  left: 0;
  top: 55%;
  transform: translateY(-50%);
  z-index: -1;
}
.error-logo img {
  height: 80vh;
}
.black-border {
  background-color: #0d0f17;
}
.error-bg {
  position: fixed;
  top: 400px;
  bottom: 200px;
  left: 0;
  right: 0;
  z-index: -2;
}
div#errorPage {
  position: fixed;
  width: 100%;
  height: 100vh;
  z-index: 2000;
  top: 0;
  left: 0;
}
.error-message {
  position: absolute;
  top: 175px;
  left: 50%;
  transform: translateX(-50%);
}
.error-text {
  font-size: 33px;
  width: 150px;
}
</style>
